import { render, staticRenderFns } from "./approval.pug?vue&type=template&id=3033b08c&lang=pug&"
import script from "./approval.ts?vue&type=script&lang=ts&"
export * from "./approval.ts?vue&type=script&lang=ts&"
import style0 from "./approval.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports